import React from "react";
import {
  Box,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  ListItemButton,
  ListItem,
  Stack,
} from "@common-ui/ui";

import { FixedSizeList } from "react-window";
import { ChevronRight } from "@mui/icons-material";

export const ClientList = ({ data, setSelection }) => {
  const renderRow = ({ index, style }) => {
    const item = data[index];
    return (
      <>
        <ListItem key={index} style={style} component="div" disablePadding>
          <ListItemButton
            // divider={true}
            onClick={() => setSelection(item)}
            sx={{
              height:
                index === data?.length - 1
                  ? "64px !important"
                  : "63px !important",
              borderTop: "1px solid #DFDFDF",
              borderBottom:
                index === data?.length - 1 ? "1px solid #DFDFDF" : "none",
              "&:hover": {
                background: "rgba(238,245,251, 1)",
              },
            }}
          >
            <ListItemAvatar>
              {/* <Avatar
                {...stringAvatar(`${item?.name}`)}
                variant="rounded"
                alt={item?.name}
              /> */}
              <Avatar
                // variant="rounded"
                alt={item?.name}
                src={`https://avatars.dicebear.com/v2/initials/${item?.name}.svg?chars=2`}
              />
            </ListItemAvatar>
            <ListItemText
              primary={
                <Typography variant="body1" fontWeight="700">
                  {item?.name}
                </Typography>
              }
              secondary={
                item?.system_id ? (
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      {item?.account ? `Account - ${item?.account}` : ""}
                    </Typography>{" "}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography
                      sx={{ display: "inline" }}
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      {/* ID - {item?.id || "None"} */}
                    </Typography>
                  </React.Fragment>
                )
              }
            />
            <Stack direction={"row"} alignItems="center">
              <Stack direction="column" spacing={1}>
                <Typography variant="body2" color="text.secondary">
                  {item?.email}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item?.phone}
                </Typography>
              </Stack>
              <ChevronRight />
            </Stack>
          </ListItemButton>
        </ListItem>
        {/* {index !== data.length ? <Divider sx={{ my: 2 }} /> : ""} */}
      </>
    );
  };
  return (
    <>
      <Box
        component="main"
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: 400,
          bgcolor: "background.paper",
          // mx: "-24px !important",
        }}
      >
        <FixedSizeList
          height={400}
          itemCount={data.length}
          itemSize={64}
          overscanCount={5}
        >
          {renderRow}
        </FixedSizeList>
      </Box>
    </>
  );
};
// function stringToColor(string) {
//   let hash = 0;
//   let i;

//   /* eslint-disable no-bitwise */
//   for (i = 0; i < string.length; i += 1) {
//     hash = string.charCodeAt(i) + ((hash << 5) - hash);
//   }

//   let color = "#";

//   for (i = 0; i < 3; i += 1) {
//     const value = (hash >> (i * 8)) & 0xff;
//     color += `00${value.toString(16)}`.slice(-2);
//   }
//   /* eslint-enable no-bitwise */

//   return color;
// }

// function stringAvatar(name) {
//   return {
//     sx: {
//       bgcolor: stringToColor(name),
//     },
//     children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
//   };
// }
